import { render, staticRenderFns } from "./MultiImageNTextEdit.vue?vue&type=template&id=2a84d318"
import script from "./MultiImageNTextEdit.vue?vue&type=script&lang=js"
export * from "./MultiImageNTextEdit.vue?vue&type=script&lang=js"
import style0 from "./MultiImageNTextEdit.vue?vue&type=style&index=0&id=2a84d318&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports